import { render, staticRenderFns } from "./SavedToast.vue?vue&type=template&id=4ad5efa0&scoped=true&"
import script from "./SavedToast.vue?vue&type=script&lang=ts&"
export * from "./SavedToast.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5efa0",
  null
  
)

export default component.exports